import { listSmileSimulationsByClinic } from "@repo/core/firestore/smileSimulation";

import { mapSmileSimulationEntityToRecordViewModel } from "../lib/view-model";
import type { SmileSimulationRecordViewModel } from "../model/view-model";
import { getSmileSimulationSignedReadUrl } from "./smileSimulation.storage";

const resolveSmileSimulationRecordUrls = async (
  captureImagePath: string,
  resultImagePath: string,
) => {
  const [captureImage, resultImage] = await Promise.all([
    getSmileSimulationSignedReadUrl(captureImagePath),
    getSmileSimulationSignedReadUrl(resultImagePath),
  ]);

  return {
    captureImage,
    resultImage,
  };
};

export const listSmileSimulationRecords = async (
  clinicId: string,
): Promise<SmileSimulationRecordViewModel[]> => {
  const entities = await listSmileSimulationsByClinic(clinicId);

  const records = await Promise.all(
    entities.map(async (entity) =>
      mapSmileSimulationEntityToRecordViewModel(
        entity,
        await resolveSmileSimulationRecordUrls(
          entity.baseImagePath,
          entity.generatedImagePath,
        ),
      ),
    ),
  );

  return records.sort(
    (left, right) =>
      new Date(right.createdAt).getTime() - new Date(left.createdAt).getTime(),
  );
};
